import { render, staticRenderFns } from "./form-review-updates.vue?vue&type=template&id=d02553fa&"
import script from "./form-review-updates.vue?vue&type=script&lang=js&"
export * from "./form-review-updates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports